module.exports = __webpack_public_path__ + "static/media/background_blank.f4776ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bg/background_blank.png
// module id = 2951
// module chunks = 0